<template>
  <b-card>
    <template #header>
      <h5 class="card-title">Visi Misi</h5>
    </template>
    <div class="d-flex align-items-center">              
      <template v-if="showContent">
        <b-form-checkbox @change="$emit('updateShowSection', $event, 'show-visi-misi', apiGet)" id="visi-misi" value="Y" unchecked-value="N" name="checkbox" v-model="showContent">Show Section?</b-form-checkbox>
      </template>
      <b-button 
        variant="secondary"
        class="btn-rounded ml-auto"
        v-if="formOpen"
        @click="closeForm">
        Close <i class="fas fa-times ml-2"></i>
      </b-button>
      <b-button
        variant="outline-info"
        class="btn-rounded ml-auto"
        @click="showUpdateForm"
        v-else
      >
        Update Content <i class="fas fa-pencil-alt ml-2"></i>
      </b-button>

    </div>
    <hr />

    
    <validation-observer
      v-slot="{ handleSubmit }"
      ref="VFormVisi"
      tag="div"
      v-if="formOpen"
    >
      <b-form @submit.prevent="handleSubmit(doSubmit)">
        <b-card class="border mb-0">
          <template #header>
            <h5 class="card-title">Content</h5>
          </template>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group mb-2">                      
                <label>Visi <strong class="text-danger">*</strong></label>
                <CKEditor 
                  id="CompanyBrief"
                  ref="inputBriefCompanyID"
                  :ready-on-focus="true"
                  :customToolbar="configCKEditor"
                  :value.sync="rowVisi.asc_content"

                />
                <VValidate 
                  name="Visi" 
                  v-model="rowVisi.asc_content"
                  :rules="validation.asc_content" 
                />
              </div>              
            </div>
            <div class="col-md-4">
              <div class="form-group mb-2">                      
                <label>Misi <strong class="text-danger">*</strong></label>
                <CKEditor 
                  id="CompanyBrief"
                  ref="inputBriefCompanyID"
                  :ready-on-focus="true"
                  :customToolbar="configCKEditor"
                  :value.sync="rowMisi.asc_content"

                />
                <VValidate 
                  name="Misi" 
                  v-model="rowMisi.asc_content"
                  :rules="validation.asc_content" 
                />
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label class="control-label">Image <span class="text-danger">*</span></label>         
                <Uploader v-model="rowVisi.asc_image" type="visi_misi"/>
                <VValidate 
                  name="Image" 
                  v-model="rowVisi.asc_image"
                  :rules="validation.asc_image" 
                />
              </div>
            </div>
          </div>
          <template #footer>
            <div class="text-right">
              <b-button variant="secondary" class="btn-rounded mr-3" @click="closeForm">Cancel</b-button>
              <button type="submit" class="btn btn-info btn-rounded">Save Changes</button>
            </div>
          </template>
        </b-card>
      </b-form>
    </validation-observer>
    <div class="row" v-else>
      <div class="col-md-8">
        <h3 class="font-weight-bold">Visi</h3>
        <div v-html="content.asc_content"></div>
        <h3 class="font-weight-bold">Misi</h3>
        <div v-html="contentMisi.asc_content"></div>
      </div>
      <div class="col-md-4">
        <img :src="parent.uploader(content.asc_image)" alt="">
      </div>
    </div>

  </b-card>
</template>
<script>
import Gen from '@/libs/Gen.js'
import CKEditor from '@/components/CKEditor'
let _ = global._

export default {
  components: {
    CKEditor
  },
  props:{
    modulePage: String
  },
  data(){
    return {
      formOpen: false,
      content: {},
      contentMisi: {},
      rowVisi: {},
      rowMisi: {},
      configCKEditor: [ 'heading', '|', 'bold','italic','underline','strikethrough','link','bulletedList','numberedList','blockQuote'],
      validation: {},
      showContent: null,
    }
  },
  computed:{
    parent(){
      return this.$parent.$parent.$parent
    }
  },
  mounted(){
    this.apiGet()
  }, 
  methods: {
    modalVisi(value){
      this.rowAlpha = _.clone(value)
      this.$bvModal.show('modalVisi')
    },
    showUpdateForm(){
      this.formOpen = true
      this.row = _.clone(this.content)
    },
    closeForm(){
      this.formOpen = false
    },
    doSubmit(){
      this.$refs.VFormVisi.validate().then(success => {
        if(!success) return 

        this.parent.swalLoading()

        Gen.apiRest('/do/' + this.modulePage, 
            { data: { type: 'updateVisiMisi', misi: this.rowMisi, visi: this.rowVisi } }
          ).then(res => {
            if(res){
              this.$swal({
                title: res.data.message,
                icon: 'success',
              }).then(() => {
                this.apiGet()
                this.closeForm()
              })
            }
          }).catch(err => {
            this.$swal({title: err.response.data.message, icon:'error'})
          })
      })
    },
    apiGet(){
      Gen.apiRest('/get/' + this.modulePage +  '/visi_misi', {}, 'GET').then(res => {
        this.content = res.data.rowVisi
        this.contentMisi = res.data.rowMisi
        this.rowMisi = res.data.rowMisi
        this.rowVisi = res.data.rowVisi
        this.validation = res.data.validation
        this.showContent = res.data.showContent
      })
    }
  }
}
</script>
